import { render, staticRenderFns } from "./permissionUser.vue?vue&type=template&id=04670615"
import script from "./permissionUser.vue?vue&type=script&lang=js"
export * from "./permissionUser.vue?vue&type=script&lang=js"
import style0 from "./permissionUser.vue?vue&type=style&index=0&id=04670615&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports